import {IController, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";

const css = require('./visMedlemIListe.scss');

export class VisMedlemIListeKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmGruppeVisMedlemIListe', {
                bindings: {medlem: '<'},
                controller: VisMedlemIListeKontroller.forInjisering(),
                template: require('./visMedlemIListe.html')
            });
    }

    static forInjisering() {
        return [
            VisMedlemIListeKontroller
        ]
    }

    constructor() {
    }

    medlem: l.GruppeMedlemListeModell; //settes via bindings/$onChanges

}

